import * as types from "./actionTypes";
import * as listApi from "../../api/listApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadCategoriesSuccess(categories) {
  return { type: types.LOAD_CATEGORIES_SUCCESS, categories };
}

export function addCategoryOptimistic(category) {
  return { type: types.ADD_CATEGORY_OPTIMISTIC, category };
}

export function loadUnapprovedCategoriesSuccess(categories) {
  return { type: types.LOAD_UNAPPROVED_CATEGORIES_SUCCESS, categories };
}

export function approveCategoryOptimistic(id) {
  return { type: types.APPROVE_CATEGORY_OPTIMISTIC, id };
}

export function rejectCategoryOptimistic(id) {
  return { type: types.REJECT_CATEGORY_OPTIMISTIC, id };
}

export function loadCategories() {
  return function (dispatch) {
    dispatch(beginApiCall());
    return listApi
      .getCategories()
      .then(categories => {
        const array = categories.map(category => category.value);
        dispatch(loadCategoriesSuccess(array));
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function addNewCategory(accessToken, newcategory) {
  return function (dispatch) {
    dispatch(addCategoryOptimistic(newcategory));
    return listApi.addCategory(accessToken, newcategory);
  };
}

export function loadUnapprovedCategories(accessToken) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return listApi
      .getUnapprovedCategories(accessToken)
      .then(categories => {
        const array = categories.map(category => category.value);
        dispatch(loadUnapprovedCategoriesSuccess(array));
        return array;
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function approveCategory(accessToken, id) {
  return function (dispatch) {
    dispatch(approveCategoryOptimistic(id));
    return listApi.approveCategory(accessToken, id);
  };
}

export function rejectCategory(accessToken, id) {
  return function (dispatch) {
    dispatch(rejectCategoryOptimistic(id));
    return listApi.rejectCategory(accessToken, id);
  };
}
